import React from "react";
import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";
import iPhone13Mini from "Utils/Assets/Images/iPhone13Mini-Silver-Portrait.png";
import coin from "Utils/Assets/Images/coin.png";

import square from "Utils/Assets/Images/square.png";
import VR from "Utils/Assets/Images/VR.png";
import money from "Utils/Assets/Images/money.png";
const EventEarner = () => {
    const bottomCards = [
        {
            icon: square,
            iconClass: "square",
            title: "Metaverse Events",
            description: "Fully immersive networking & social interaction.",
            animation: "fade-left",
        },
        {
            icon: VR,
            iconClass: "VR",
            title: "VR Shopping",
            description: "Virtual stores with real-world payments.",
            animation: "fade-up",
        },
        {
            icon: money,
            iconClass: "money",
            title: "Play-to-Earn Economy",
            description: "Users earn while engaging in digital activities.",
            animation: "fade-right",
        },
    ];

    return (
        <div className={styles.header}>
            <div className={styles.bgImageContainer}></div>
            <div className={styles.headerContent}>
                <div>
                    <h1 className={styles.title}>
                        Turn Every Event into an Earning Opportunity
                    </h1>
                </div>

                <MeetUsWrapper>
                    <div className={styles.eventEarnerContent}>
                        <div className={styles.phoneWrapper}>
                            <img
                                src={iPhone13Mini}
                                alt="iPhone 13 Mini"
                                className={styles.phone}
                            />

                            {/* Coins */}
                            <img
                                src={coin}
                                alt="coin top"
                                className={`${styles.coin} ${styles.top} ${styles.coinTop}`}
                            />

                            <img
                                src={coin}
                                alt="coin bottom"
                                className={`${styles.coin} ${styles.bottom} ${styles.coinBottom}`}
                            />

                            <img
                                src={coin}
                                alt="coin left"
                                className={`${styles.coin} ${styles.left} ${styles.coinLeft}`}
                            />

                            <img
                                src={coin}
                                alt="coin right"
                                className={`${styles.coin} ${styles.right} ${styles.coinRight}`}
                            />
                        </div>

                        <div className={styles.cardsBottom}>
                            {bottomCards.map((card, index) => (
                                <div className={styles.cardBottom} key={index}>
                                    <img src={card.icon} alt={card.title} />
                                    <div>
                                        <p className={styles.cardBottomText}>
                                            {card.title}
                                        </p>
                                        <p className={styles.cardBottomDes}>
                                            {card.description}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className={styles.earningsButtonWrapper}>
                            <button>Learn More</button>
                        </div>
                    </div>
                </MeetUsWrapper>
            </div>
        </div>
    );
};

export default EventEarner;
